import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useStoneAccountList } from '@/core/domain/stone/stoneAccount/stoneAccount.hooks';
import { StoneAccount } from '@/core/domain/stone/stoneAccount/stoneAccount.types';
import { applyCpfCnpjMask } from '@/utils/mask';
import { Table, Tooltip } from 'antd';
import StoneAccountDevicesModal from '../StoneAccountDevices';
import { useDisclosure } from '@/hooks';
import { useState } from 'react';
import ActionIcon from '@/components/_common/ActionIcon';
import { FaMobileAlt } from 'react-icons/fa';
import StatusTag from '@/components/_common/StatusTag';

export default function StoneAccountList() {
  const stoneAccountList = useStoneAccountList();

  const [stoneAccount, setStoneAccount] = useState<StoneAccount>();

  const [modalOpen, modalAction] = useDisclosure(false, {
    onClose: () => setStoneAccount(undefined),
  });

  return (
    <>
      <Table
        dataSource={stoneAccountList.data}
        columns={[
          { dataIndex: 'accountId', title: 'Id da conta' },
          { dataIndex: 'accountName', title: 'Nome da conta' },
          { dataIndex: 'accountSocialReason', title: 'Razão social' },
          {
            dataIndex: 'accountCnpj',
            title: 'CNPJ',
            render(cnpj) {
              return applyCpfCnpjMask(cnpj);
            },
          },
          {
            title: 'Situação',
            dataIndex: 'active',
            render(active) {
              return (
                <>
                  {active && <StatusTag color="green" label="Ativado" />}
                  {!active && <StatusTag color="default" label="Desativado" />}
                </>
              );
            },
          },
          {
            title: 'Ação',
            align: 'right',
            render(item) {
              return (
                <SpaceForButton
                  justifyContent="flex-end"
                  align="center"
                  size="middle"
                >
                  <Tooltip title="Gerenciar dispositivos">
                    <div>
                      <ActionIcon
                        onClick={() => {
                          setStoneAccount(item);
                          modalAction.open();
                        }}
                      >
                        <FaMobileAlt size={24} />
                      </ActionIcon>
                    </div>
                  </Tooltip>
                </SpaceForButton>
              );
            },
          },
        ]}
        loading={stoneAccountList.isLoading}
        scroll={{ x: true }}
        pagination={false}
      />

      <StoneAccountDevicesModal
        stoneAccount={stoneAccount}
        open={modalOpen}
        onClose={modalAction.close}
      />
    </>
  );
}
